import { Injectable } from '@angular/core';

import { Observable } from 'rxjs/Observable';
// Statics
import 'rxjs/add/observable/throw';
import {WsService} from "../../utils/network/ws.service";
// Operators
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/delay';
import { Headers, RequestOptions } from '@angular/http';
import { Http, Response } from '@angular/http';
import {environment} from '../../../environments/environment';
declare var $;
@Injectable()
export class NetworkService {


    constructor(private http: Http, private wsService: WsService) {
        console.log("Creating network service");
    }
    
     // url = "http://localhost:8080/wb/";
      
     postRecordingFailed(url){
        return this.privPost(environment.contentsBackendUrl, "/videoContent/fail/"+url, null);
     }
     privPost(backend, url, body){
         let headers = new Headers({ 'Content-Type': 'application/json' });
        let options = new RequestOptions({ headers: headers, withCredentials: true });
        return this.http.post(backend + url, body, options)
            .map(this.extractData)
            .catch(this.handleError);
     }
     checkRoom(){
         
     }
    post(url, body, showAlert=true) {
        this.showAlert = showAlert;
        return this.privPost(environment.wbBackendUrl, url, body);
        /*
        let headers = new Headers({ 'Content-Type': 'application/json' });
        let options = new RequestOptions({ headers: headers, withCredentials: true });
        return this.http.post(environment.wbBackendUrl + url, body, options)
            .map(this.extractData)
            .catch(this.handleError);
*/
        // return Observable.of(true).delay(1000).do(val => this.isLoggedIn = true);
    }
/*
    
    postFile(urlToPost: string, requirement, file, success, error) {
        let urlToSend = environment.backendUrl + urlToPost
        var data = new FormData();
        data.append("file", file);
        data.append("dto", new Blob([JSON.stringify(requirement)], { type: "application/json" }));
        $.ajax({
            url: urlToSend,
            data: data,
            cache: false,
            contentType: false,
            processData: false,
            type: 'POST',
            error: error,
            success: success
        });
    }
*/
showAlert = true;
    private handleError(error: any) {

        //let errMsg = (error.message) ? error.message :
        // error.status ? `${error.status} - ${error.statusText}` : 'Server error';
        console.error(error); // log to console instead
        //this.translate.get("ERROR_COMMON").subscribe((res: string) => {
        if (this.showAlert)
        alert("Something is not right, please, try again.");
        //});

        return Observable.throw(error);
    }
    private extractData(res: Response) {
        let body = res.json();
        console.log(body)
        if (body.status === false) {
            //console.log(body.object.description)
            //alert(body.object.description);
            return body;
        }
        return body.object || {};
    }

}


// WEBPACK FOOTER //
// /app/src/app/wb/player/network.service.ts